<template>
  <!-- 菜单权限管理 -->
  <div class="page-wrap">
    <div class="page-container">
      <!-- 搜索筛选卡片 毛玻璃+大圆角+弥散阴影 -->
      <div class="search-card">
        <el-form inline :model="searchForm">
          <el-form-item label="抖音号id:">
            <el-input v-model="douyinId" placeholder="选填，精准id" clearable size="mini"></el-input>
          </el-form-item>
          <el-form-item label="抖音号名称:">
            <el-input v-model="douyinName" placeholder="选填，可模糊" clearable size="mini"></el-input>
          </el-form-item>
          <!-- 其他筛选项 -->
          <el-form-item>
            <el-button type="success" size="mini" @click="douyinAccountlistFun()">搜索</el-button>
            <!-- <el-button size="mini">重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>

      <div class="btn-toolbar">
        <!-- 左侧按钮组 -->
        <div class="left-buttons">
          <el-button-group class="my-btn-group">
            <el-button plain size="mini" icon="el-icon-coin" class="btn-green"
              @click="changedouyinIdviewFun()">添加抖音号</el-button>
          </el-button-group>
          <el-button @click="changededouyinIdviewFun()" plain size="mini" class="btn-red">批量删除</el-button>
        </div>
      </div>

      <!-- 下方表格卡片 -->
      <div class="table-card">
        <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="userName" label="创建人" width="100"> </el-table-column>
          <el-table-column prop="douyinName" label="抖音号名称" width="180"> </el-table-column>
          <el-table-column prop="douyinId" label="抖音号id"> </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180"> </el-table-column>
          <el-table-column prop="regionRemark" label="操作" width="100">
            <template #default="scope">
              <el-button type="danger" @click="douyinIddeleteFun2(scope)" icon="el-icon-delete" circle
                size="mini"></el-button>
            </template>

          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <pagination @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :total="total"
          :pagesize="pagesize" :currentPage="currentPage"></pagination>
      </div>
    </div>

    <!-- 添加抖音号弹窗控制 -->
    <el-dialog douyinId="添加抖音号" v-model="douyinIdview" width="60%" class="dialog‑green">
      <el-form ref="formRef" :model="form" label-width="120px">
        <el-form-item label="抖音号id">
          <el-input v-model="form.douyinId" placeholder="请输入抖音号id" clearable style="width:520px"></el-input>
        </el-form-item>

        <el-form-item label="抖音号名称">
          <el-input v-model="form.douyinName" placeholder="请输入抖音号名称" clearable style="width:520px"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="mini" @click="douyinAccountaddFun()">添加抖音号</el-button>
          <!-- <el-button v-if="sId != ''" type="primary" size="mini" @click="packageupdateFun()">修改抖音号</el-button> -->
          <el-button size="mini" @click="handleResetPackage()">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 删除抖音号管理弹窗控制 -->
    <el-dialog v-model="dedouyinIdview" douyinId="删除抖音号" width="30%">
      <el-form label-width="120px">
        <el-form-item>
          <font style="color:red">确定删除所选中的抖音号？</font>
        </el-form-item>
      </el-form>
      <el-form-item>
        <el-button type="primary" size="mini" @click="douyinIddeleteFun()">确定删除</el-button>
        <el-button size="mini" @click="changededouyinIdviewFun()">取消</el-button>
      </el-form-item>
    </el-dialog>
  </div>
</template>

<script>
import { douyinAccountlist, douyinAccountadd, douyinAccountdeleteByIds } from '@/request/new/ylyBatch'
import { ElMessage } from 'element-plus'
import { inject, reactive, toRefs, watch } from 'vue'
import pagination from '@/components/pagination.vue' // 导入分页组件

export default {
  name: 'ylydouyinId',
  components: { pagination },
  setup() {
    const state = reactive({
      //抖音号
      douyinId: '',
      //抖音号包
      douyinName: '',
      //选中的id
      sId: [],
      //表格数据
      tableData: [],

      //抖音号重置数据
      restform: {
        douyinName: '',
        douyinId: ''
      },
      //添加抖音号的数据
      form: {
        douyinName: '',
        douyinId: ''
      },
      //添加抖音号开关
      douyinIdview: false,
      //添加抖音号开关控制
      changedouyinIdviewFun: () => {
        state.douyinIdview = !state.douyinIdview
      },
      //删除抖音号
      dedouyinIdview: false,
      //删除抖音号开关控制
      changededouyinIdviewFun: () => {
        state.dedouyinIdview = !state.dedouyinIdview
      },
      //删除按钮
      douyinIddeleteFun2: (scope) => {
        state.sId = [scope.row.id]
        state.changededouyinIdviewFun()
      },
      // 条数
      pagesize: 50,
      // 当前页数
      currentPage: 1,
      // 总数
      total: 100,
      // 页数 发生改变
      handleCurrentChange: (e) => {
        state.currentPage = e
        douyinAccountlistFun()
      },
      // 个数 发生改变
      handleSizeChange: (e) => {
        state.pagesize = e
        douyinAccountlistFun()
      },
      //重置抖音号
      handleResetPackage: () => {
        // 深拷贝 restform，切断引用
        state.form = JSON.parse(JSON.stringify(state.restform))
      },
      //添加抖音号
      douyinAccountaddFun: () => {
        if (state.form.douyinName.length > 0 && state.form.douyinId != '') {

          const datas = {
            douyinName: state.form.douyinName,
            douyinId: state.form.douyinId,
          }
          douyinAccountadd(datas).then((res) => {
            if (res.code == 200) {
              ElMessage.success('添加成功')
              state.form = JSON.parse(JSON.stringify(state.restform))
              state.changedouyinIdviewFun()
              douyinAccountlistFun()
            }
          })
        } else {
          ElMessage.error('数据不能为空')
        }
      },
      //批量删除抖音号

      //删除抖音号
      douyinIddeleteFun: () => {
        if (state.sId.length > 0) {
          douyinAccountdeleteByIds(state.sId).then((res) => {
            if (res.code == 200) {
              ElMessage.success('删除成功')
              state.changededouyinIdviewFun()
              douyinAccountlistFun()
              state.sId = []
            }

          })
        } else {
          ElMessage.error('请先选中抖音号')
        }

      },



    })

    // 获取复选框的值
    const handleSelectionChange = (val) => {
      state.sId = []
      val.forEach((item) => {
        state.sId.push(item.id)
      })
    }

    //分页查询当前登录用户的抖音号
    const douyinAccountlistFun = () => {
      const datas = {
        douyinName: state.douyinName,
        douyinId: state.douyinId,
        currentPage: state.currentPage,
        size: state.pagesize,

      }
      douyinAccountlist(datas).then((res) => {
        state.currentPage = res.data.currenPage
        state.total = res.data.totalSize
        state.tableData = res.data.data
      })
    }

    douyinAccountlistFun()

    return {
      // 结构赋值，暴露出去就不用 state.xx
      ...toRefs(state),
      douyinAccountlistFun,
      handleSelectionChange
    }
  },

}
</script>

<style lang="scss" scoped>
// 全局页面浅色渐变背景
.page-wrap {
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(135deg, #f7f9fc 0%, #edf2fa 100%);
}

.page-container {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

// 搜索卡片：毛玻璃、大圆角、弥散柔和阴影
.search-card {
  border-radius: 18px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.85);
  transition: all 0.32s ease;
}

// 表格卡片
.table-card {
  border-radius: 18px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.85);
  overflow: hidden;
}

.pagination-wrap {
  padding: 8px 4px;
}

.btn-toolbar {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.left-buttons {
  display: flex;
  gap: 2px;
  flex-shrink: 1;
  overflow-x: auto;
  padding-bottom: 4px;
}

// ========= ElementPlus 组件深度修改 现代UI 大圆角+hover平滑动画 =========
:deep() {

  // 输入框、选择器大圆角
  .el-input__inner,
  .el-select .el-input__inner {
    border-radius: 12px !important;
    border-color: #e2e8f0;
    transition: all 0.28s cubic‑bezier(0.4, 0, 0.2, 1);

    &:hover {
      border‑color: #b8c8e3;
      box‑shadow: 0 0 0 3px rgba(64, 158, 255, 0.08);
    }

    &:focus {
      box‑shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
    }
  }

  // 按钮统一大圆角+平滑hover微交互
  .el-button {
    border‑radius: 12px !important;
    transition: all 0.28s cubic‑bezier(0.4, 0, 0.2, 1);
    box‑shadow: 0 2px 6px rgba(0, 0, 0, 0.04);

    &:hover {
      transform: translateY(-1px);
      box‑shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
    }

    &:active {
      transform: translateY(0px);
    }
  }

  // 表格样式美化，去掉生硬边框，圆角
  .el-table {
    border‑radius: 14px;
    overflow: hidden;
  }

  .el-table th.el-table__cell {
    background‑color: #f4f7fc !important;
  }

  .el-table__row:hover>td {
    background‑color: rgba(64, 158, 255, 0.04) !important;
  }

  // 弹窗 毛玻璃大圆角弥散阴影
  .modern-dialog.el-dialog {
    border‑radius: 20px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.78);
    backdrop‑filter: blur(16px);
    -webkit‑backdrop‑filter: blur(16px);
    box‑shadow: 0 12px 45px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.9);
  }

  .el-dialog__header {
    padding: 22px 26px 12px;
  }

  .el-dialog__body {
    padding: 10px 26px 22px;
  }

  // 分页组件圆角
  .el-pagination {

    .el-pager li,
    .el-pagination__btn {
      border‑radius: 10px;
    }
  }
}

/* 你的按钮颜色样式保留 */
.btn-orange {
  background-color: #ff9500;
  color: white;
  border: none;
}

.btn-green {
  background-color: #00b42a;
  color: white;
  border: none;
}

.btn-blue {
  background-color: #409eff;
  color: white;
  border: none;
}

.btn-dark-blue {
  background-color: #2b5cb8;
  color: white;
  border: none;
}

.btn-purple {
  background-color: #722ed1;
  color: white;
  border: none;
}

.btn-red {
  background-color: #f53f3f;
  color: white;
  border: none;
}

.btn-dark {
  background-color: #1d2129;
  color: white;
  border: none;
}

.btn-light-blue {
  background-color: #69b1ff;
  color: white;
  border: none;
}

.btn-sky {
  background-color: #40c9ff;
  color: white;
  border: none;
}
</style>